export default (data) => ({
    _els: {
        group: null,
        wrapper: null,
        feedback: null,
        helper: null,
        error: null,
    },
    init() {
        //
    },

    /**
     * @returns {string}
     */
    get id() {
        return this.$el.id;
    },

    /**
     * @returns {string}
     */
    get name() {
        return this.$el.name;
    },

    /**
     * @returns {int|string|null}
     */
    get value() {
        return this.$el.value || null;
    },

    /**
     * @returns {FileList|null}
     */
    get files() {
        if (this.type !== 'file') {
            return null;
        }
        if (!this.$el.files.length) {
            return null;
        }

        return this.$el.files;
    },

    /**
     * @param {int|string} value
     */
    set value(value) {
        this.clearError();

        this.$el.value = value;
    },

    /**
     * @returns {string}
     */
    get type() {
        /**
         * Splitting because :
         *     - select:not([multiple]) --> select-one
         *     - select:[multiple] --> select-multiple
         */
        return (this.$el.type || '').split('-')[0];
    },

    /**
     * @returns {HTMLLabelElement|null}
     */
    get label() {
        return this.$el.labels[0] || null;
    },

    /**
     * @returns {string}
     */
    get placeholder() {
        return this.$el.placeholder;
    },

    /**
     * @returns {int|string}
     */
    get min() {
        return this.$el.min;
    },

    /**
     * @returns {int|string}
     */
    get max() {
        return this.$el.max;
    },

    /**
     * @returns {string}
     */
    get autocomplete() {
        return this.$el.autocomplete;
    },

    /**
     * @returns {boolean}
     */
    get autofocus() {
        return !!this.$el.autofocus;
    },

    /**
     * @returns {HTMLElement}
     */
    get group() {
        if (!this._els.group) {
            this._els.group = document.querySelector(`#field-group-${this.id}`);
        }

        return this._els.group;
    },

    /**
     * @returns {HTMLElement|null}
     */
    get wrapper() {
        if (!this._els.wrapper) {
            this._els.wrapper = this.group.querySelector('.field-wrapper');
        }

        return this._els.wrapper || null;
    },

    /**
     * @returns {HTMLElement|null}
     */
    get feedback() {
        if (!this._els.feedback) {
            this._els.feedback = this.group.querySelector(`#field-feedback-${this.id}`);
        }

        return this._els.feedback || null;
    },

    /**
     * @returns {HTMLElement|null}
     */
    get helper() {
        if (!this._els.helper) {
            this._els.helper = this.group.querySelector(`#field-helper-${this.id}`);
        }

        return this._els.helper || null;
    },

    /**
     * @returns {boolean}
     */
    get valid() {
        return !this._els.error;
    },

    /**
     * @returns {HTMLElement|null}
     */
    get error() {
        if (!this.group.classList.contains('is-invalid')) {
            return null;
        }

        if (!this._els.error) {
            this._els.error = this.group.querySelector(`#field-feedback-${this.id}`);
        }

        return this._els.error || null;
    },

    /**
     * @param {string|null}
     */
    set error(message) {
        this.setError(message);
    },

    /**
     * @returns {boolean}
     */
    get isRequired() {
        return !!this.$el.required;
    },

    /**
     * @returns {boolean}
     */
    get isDisabled() {
        return !!this.$el.disabled;
    },

    /**
     * @returns {boolean}
     */
    get isChecked() {
        return !!this.$el.checked;
    },

    /**
     * @returns {boolean}
     */
    get isReadOnly() {
        return !!this.$el.readOnly;
    },

    /**
     * @returns {boolean}
     */
    get allowsMultiple() {
        return !!this.$el.multiple;
    },

    /**
     * @returns {boolean}
     */
    get isEmpty() {
        return !(this.value || '').trim().length;
    },

    /**
     * @returns {boolean}
     */
    get isNotEmpty() {
        return !this.isEmpty;
    },

    /**
     * @returns {boolean}
     */
    get isFilled() {
        return this.isNotEmpty;
    },

    /**
     * @param {string|null} message If a string, set's the error message, else, removes it.
     */
    setError(message) {
        const feedbackId = `field-feedback-${this.id}`;

        if (!this._els.error) {
            this._els.error = this.group.querySelector(`#${feedbackId}`);
        }

        if (message == null) {
            if (this._els.error) {
                this._els.error.remove();
                this._els.error = null;
            }

            this.$el.removeAttribute('aria-describedby');
            this.$el.removeAttribute('aria-errormessage');
            this.$el.removeAttribute('aria-invalid');

            this.group.classList.replace('is-invalid', 'is-valid');

            this._els.feedback = null;

            // this.emit('field:error', {
            //     hasError: false,
            //     error: null,
            // });

            return;
        }

        if (!this._els.error) {
            this._els.error = document.createElement('small');

            this._els.error.id = feedbackId;
            this._els.error.className = 'field-feedback w-full block mt-1 italic text-error-600';
            this._els.error.setAttribute('aria-live', 'assertive');

            this.group.appendChild(this._els.error);
        }

        this._els.error.textContent = message;

        this.$el.setAttribute('aria-describedby', feedbackId);
        this.$el.setAttribute('aria-errormessage', feedbackId);
        this.$el.setAttribute('aria-invalid', true);

        this.group.classList.replace('is-valid', 'is-invalid');

        this._els.feedback = null;

        // this.emit('field:error', {
        //     hasError: true,
        //     error: this._els.error,
        // });
    },

    /**
     * @returns {void}
     */
    clearError() {
        this.setError(null);
    },

    /**
     * @returns {void}
     */
    reset() {
        this.clearError();

        if (['radio', 'checkbox'].includes(this.type)) {
            this.$el.checked = false;

            return;
        }

        this.$el.value = '';
    },

    /**
     * @param {InputEvent} e
     */
    onInput(e) {
        if (!this.valid) {
            this.clearError();
        }
    },
});